'use strict';

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default')['default'];

exports.__esModule = true;
exports['default'] = createStore;

var _redux = require('redux');

var _middlewareClientMiddleware = require('./middleware/clientMiddleware');

var _middlewareClientMiddleware2 = _interopRequireDefault(_middlewareClientMiddleware);

var _middlewareUrlMiddleware = require('./middleware/urlMiddleware');

var _middlewareUrlMiddleware2 = _interopRequireDefault(_middlewareUrlMiddleware);

// import transitionMiddleware from './middleware/transitionMiddleware';

function createStore(client, history, data) {
  var middleware = [_middlewareClientMiddleware2['default'](client), _middlewareUrlMiddleware2['default'](history)];

  var finalCreateStore = undefined;
  if (__DEVELOPMENT__ && __CLIENT__ && __DEVTOOLS__) {
    var _require = require('redux-devtools');

    var persistState = _require.persistState;

    var DevTools = require('../components/DevTools/DevTools');
    finalCreateStore = _redux.compose(_redux.applyMiddleware.apply(undefined, middleware), window.devToolsExtension ? window.devToolsExtension() : DevTools.instrument(), persistState(window.location.href.match(/[?&]debug_session=([^&]+)\b/)))(_redux.createStore);
  } else {
    finalCreateStore = _redux.applyMiddleware.apply(undefined, middleware)(_redux.createStore);
  }

  var reducer = require('./modules/reducer');
  var store = finalCreateStore(reducer, data);

  if (__DEVELOPMENT__ && module.hot) {
    module.hot.accept('./modules/reducer', function () {
      store.replaceReducer(require('./modules/reducer'));
    });
  }

  return store;
}

module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/redux/create.js
 ** module id = 1029
 ** module chunks = 2
 **/